export default "__VITE_ASSET__DPeS5eCa__"